import { Icon } from '@chakra-ui/react';

export const DollarCircle = (props) => (
  <Icon width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>dollar-payments-onversion.2</title>
    <g id="Design" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="story" transform="translate(-1020.000000, -944.000000)">
        <g id="Group-15" transform="translate(357.000000, 810.000000)">
          <g id="dollar-payments-onversion.2" transform="translate(663.000000, 134.000000)">
            <polygon id="Path" points="0 0 48 0 48 48 0 48" />
            <path
              d="M9.632,34.776 C12.924,39.148 18.138,42 24,42 C33.9,42 42,33.9 42,24 C42,14.1 33.9,6 24,6"
              id="Path"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9.632,34.776 C7.364,31.764 6,28.038 6,24 C6,14.1 14.1,6 24,6"
              id="Path"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeDasharray="5"
            />
            <line
              x1="23.7"
              y1="14"
              x2="23.7"
              y2="16.5"
              id="Path"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <line
              x1="23.7"
              y1="34"
              x2="23.7"
              y2="31.5"
              id="Path"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M28.674,20 C28.544,18.048 26.934,16.5 24.95,16.5 L22.21,16.5 C20.27,16.5 18.7,18.072 18.7,20.01 C18.7,21.62 19.796,23.024 21.356,23.416 L26.042,24.592 C27.604,24.984 28.698,26.388 28.698,27.998 C28.698,29.938 27.126,31.508 25.188,31.508 L22.448,31.508 C20.46,31.508 18.85,29.956 18.722,28"
              id="Path"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
      </g>
    </g>
  </Icon>
);
